import { useMemo } from "react";
import { useAnswerersV2 } from "./useAnswerers";

export const useAgreedAnswerers = (params?: { isInit?: boolean }) => {
    const { answerers, isLoading, clearCache } = useAnswerersV2(params);

    const agreedAnswerers = useMemo(
        () =>
            answerers?.filter(
                (answerer) => answerer.isPrivacyAndUsageTermsAgreed
            ) ?? [],
        [answerers]
    );

    return {
        answerers: agreedAnswerers,
        isLoading,
        clearCache,
    };
};
